import { Component } from "react";
import { Link } from "react-router-dom";
import 'font-awesome/css/font-awesome.min.css';
import { appConfig } from "../../config"
import callCenter from '../../images/halo23.png'

export default class extends Component {
    render() {
        return (
            <>
                <footer className="footer py-4 d-lg-block d-none" style={{backgroundColor:"#F3F3F3"}}>
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-3 col-md-3 col-12 mx-auto">
                                <ol style={{listStyle:'none'}}>
                                        <li>
                                            <Link className="footer-items" style={{textDecoration:'none', fontSize:'14px'}} to="https://drive.google.com/drive/u/0/folders/1_aazXBeGBe_hl_U9p5XLXP4UCbjaw9x-" target="_blank" rel="noopener noreferrer">Bantuan dan Panduan</Link>
                                        </li>
                                        <li>
                                            <Link className="footer-items" style={{textDecoration:'none', fontSize:'14px'}} to="https://astragraphia.co.id/id/pemberitahuan-privasi" target="_blank" rel="noopener noreferrer">Pemberitahuan Privasi</Link>
                                        </li>
                                        <li>
                                            <Link className="footer-items" style={{textDecoration:'none', fontSize:'14px'}} to="https://documentsolution.com/id/konten/dukungan-konsumen/icare" target="_blank" rel="noopener noreferrer">Tentang iCare</Link>
                                        </li>
                                        <li className="mt-2">
                                            <Link className="footer-items" style={{textDecoration:'none', fontSize:'14px'}}>
                                                <img src={callCenter} alt="astragraphia" width="160" />
                                            </Link>
                                        </li>
                                </ol>
                            </div>
                            <div className="col-lg-3 col-md-3 col-12 mx-auto">
                                <p className="mb-2" style={{fontSize:'14px'}}>Follow Us</p>
                                <div className="d-flex align-items-center mb-2">
                                    <Link className="footer-items" to="https://www.youtube.com/user/Astragraphia" target="_blank" rel="noopener noreferrer">
                                        <i className="fa fa-youtube-play me-2" style={{fontSize:'22px'}}></i>
                                        <span style={{fontSize:'14px',}}>Astragraphia Document Solution</span>
                                    </Link>
                                </div>
                                <div className="d-flex align-items-center mb-2">
                                    <Link className="footer-items" to="https://www.instagram.com/astragraphiadocsol/" target="_blank" rel="noopener noreferrer">
                                        <i className="fa fa-instagram me-2" style={{fontSize:'22px'}}></i>
                                        <span style={{fontSize:'14px'}}>astragraphiadocsol</span>
                                    </Link>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div className="d-flex align-items-center w-100">
                        <hr className="w-100"/>
                        <div className="d-block px-4" style={{whiteSpace:'nowrap', fontSize:'14px'}}>Powered by Astragraphia - Version { appConfig.VERSION }</div>
                        <hr className="w-100"/>
                    </div>                    
                </footer>
            </>
        )
    }
}